import React from 'react';

const About = () => {
  return <h1 style={{backgroundColor:'blue'}}>Welcome to the About Page</h1>;
};

export default About;
